export function getTargetPath(linkedSceneName, language) {
    return `/${language}/${linkedSceneName}`;
}

export function getLocaleString(currentLanguage) {
    let parts = currentLanguage.split("_")
    return `${parts[0]}_${parts[1].toUpperCase()}`
}


export function getObsessLocaleFormat(language) {
    return language;
    // let languageArr = language.split("_");
    // return `${languageArr[0]}_${languageArr[1].toUpperCase()}`;
}

export function getLocaleForAPI(language) {
    return localeMapForAPI[language];
}

const localeMapForAPI = {
    'us_en': 'en_US',
    'jpn_ja': 'ja_JP',
    'esp_es': 'es_ES',
    'fra_fr': 'fr_FR',
    'ita_it': 'it_IT',
    'mex_es': 'es_MX',
    'eu_en': 'en_EU',
    'eu_de': 'de_EU',
    'gb_en': 'en_GB',
    'aus_en': 'en_AU',
    'ca_en': 'en_CA',
    'kor_kr': 'ko_KR',
}

